module.exports = __webpack_public_path__ + "static/media/workingmemory-words-intro.acced928.mp3";